import axios from "axios";

export const PRESTADOR_URL = `PrestadorSempre`;

export const prestadorSempreServices = {
  getById: (id: string) => {
    return axios.get<any>(`${PRESTADOR_URL}/${id}`);
  },
  lookup: (queryParams: any) => {
    return axios.get<any>(`${PRESTADOR_URL}/Lookup`, {
      params: {
        ...queryParams,
      },
    });
  },
};
